<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onConfirm"
  >
    <v-card-text class="mt-2">
      <v-row>
        <v-col>
          <v-text-field
            label="Från plats"
            outlined
            v-model="model.from_place"
            :rules="[required]"
          />
        </v-col>
        <v-col>
          <v-text-field
            label="Till plats"
            outlined
            v-model="model.to_place"
            :rules="[required]"
          />
        </v-col>
        <v-col>
          <v-text-field
            label="Tid (minuter)"
            outlined
            type="number"
            v-model.number="model.duration"
            :rules="[required]"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Avbryt</v-btn>
      <v-btn rounded type="submit" color="primary" :loading="pending"
        >Skapa</v-btn
      >
    </v-card-actions>
  </v-form>
</template>

<script>
import { required } from '@/common/validationRules'
import gql from 'graphql-tag'

export default {
  name: 'MasterdataBusMatrixCreateModal',

  props: {
    refetch: Function
  },

  data: () => ({
    required,
    valid: true,
    pending: false,

    model: {
      from_place: '',
      to_place: '',
      duration: 0
    }
  }),

  methods: {
    async onConfirm() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return

      this.pending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceBusDurationEntry!) {
            createBusDurationEntry(payload: $payload) {
              from_place
              to_place
              duration
            }
          }
        `,
        variables: {
          payload: this.model
        }
      })

      this.pending = false
      this.refetch()
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
